import { Type } from '@angular/core';
import { GameId } from 'src/app/shared/models/game/game-id';
import type { GameUiComponent } from '../services/game-ui/game-ui-component.interface';
import type { UxGameController } from '../services/controllers/game-legacy/ux-game-controller';
import type { GenericSceneController } from '../services/controllers/scene-controllers/scene-controller-factory';

type GameUiControlComponent = Type<GameUiComponent<UxGameController | GenericSceneController>>;

// Async loader functions for lazy loading game UI components
export const GameUiControlLoaders: Record<GameId, () => Promise<GameUiControlComponent>> = {
  [GameId.Blackjack]: async () => {
    const { BlackjackGameControlsComponent } =
      await import('../controls/blackjack-game-controls/blackjack-game-controls.component');
    return BlackjackGameControlsComponent;
  },
  [GameId.Blocks]: async () => {
    const { BlocksGameControlsComponent } =
      await import('../controls/blocks-game-controls/blocks-game-controls.component');
    return BlocksGameControlsComponent;
  },
  [GameId.Marbles]: async () => {
    const { MarblesGameControlsComponent } =
      await import('../controls/marbles-game-controls/marbles-game-controls.component');
    return MarblesGameControlsComponent;
  },
  [GameId.Solitaire]: async () => {
    const { SolitaireGameControlsComponent } =
      await import('../controls/solitaire-game-controls/solitaire-game-controls.component');
    return SolitaireGameControlsComponent;
  },
  [GameId.TwentyOne]: async () => {
    const { TwentyOneGameControlsComponent } =
      await import('../controls/twentyone-game-controls/twentyone-game-controls.component');
    return TwentyOneGameControlsComponent;
  },
  [GameId.Slots]: async () => {
    const { SlotsGameControlsComponent } =
      await import('../controls/slots-game-controls/slots-game-controls.component');
    return SlotsGameControlsComponent;
  },
  [GameId.Plinko]: async () => {
    const { PlinkoGameControlsComponent } =
      await import('../controls/plinko-game-controls/plinko-game-controls.component');
    return PlinkoGameControlsComponent;
  },
  [GameId.VideoPoker]: async () => {
    const { VideoPokerGameControlsComponent } =
      await import('../controls/videopoker-game-controls/videopoker-game-controls.component');
    return VideoPokerGameControlsComponent;
  },
  [GameId.HiLo]: async () => {
    const { HiLoGameControlsComponent } =
      await import('../controls/hilo-game-controls/hilo-game-controls.component');
    return HiLoGameControlsComponent;
  },
  [GameId.Bingo]: async () => {
    const { BingoGameControlsComponent } =
      await import('../controls/bingo-game-controls/bingo-game-controls.component');
    return BingoGameControlsComponent;
  },
};
